<div class="fluid-container">
  <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">
    <div class="tw:flex-1 tw:m-0 tw:p-0">
      <form [formGroup]="addClientRowForm">
        <table class="table table-hover sub-table add-client-row__table">
          <thead>
            <tr class="main-user-table-header-row" [ngClass]="{'custom-striped disable-custom-striped': isCustomStripedRow, 'disable-row-hover': !isCustomStripedRow}">
              <th scope="col"> Assign Client </th>
              <th scope="col"> Admin </th>
              <th scope="col"> Custodian </th>
              <th scope="col"> Reports </th>
            </tr>
          </thead>
          <tbody>

            <tr class="main-user-table-row" [ngClass]="{'custom-striped': isCustomStripedRow}">
              <td class="tw:align-middle client-name-td">
                <div>Client name</div>
                <app-searchable-select formControlName="selectedClient" [items]="clientList"
                  displayField="dropdownDisplay" placeholder="Select a client"
                  searchPlaceholder="Search clients…"></app-searchable-select>
              </td>
              <td class="tw:align-middle add-client-row__tick" data-label="Admin">
                <label class="field__checkbox"><input type="checkbox" aria-label="Admin" [checked]="clientToAdd.isAdmin" (change)="assignClientRole({checked: $event.target.checked},'ADMIN')" /></label>
              </td>
              <td class="tw:align-middle add-client-row__tick" data-label="Custodian">
                <label class="field__checkbox"><input type="checkbox" aria-label="Custodian" [checked]="clientToAdd.isCustodian" (change)="assignClientRole({checked: $event.target.checked},'CUSTODIAN')" /></label>
              </td>
              <td class="tw:align-middle add-client-row__tick" data-label="Reports">
                <label class="field__checkbox"><input type="checkbox" aria-label="Reports" [checked]="clientToAdd.isReport" (change)="assignClientRole({checked: $event.target.checked},'REPORT')" /></label>
              </td>
            </tr>
            <tr class="no-border" [ngClass]="{'custom-striped disable-custom-striped': isCustomStripedRow, 'disable-row-hover': !isCustomStripedRow}">
              <td colspan="2" class="tw:text-danger">
                {{
                validationError
                }}
              </td>
              <td colspan="2">
                <div class="btn-align tw:float-right">
                  <button type="button" class="btn btn-primary tw:mr-1" name="btnAddClient" value="Add Client" (click)="add()">Add</button>
                  <button type="button" class="btn btn-primary tw:ml-1" name="btnCancel" value="Cancel" (click)="cancel()">Cancel</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
</div>
